define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "csi/action/Controller",
    "csi/comm/PostRequest"
], function(declare,lang,Controller,PostRequest) {

return declare(Controller, {

        process: function() {
            // summary: issue request so as to be able to receive return value
            var req = this.m_action.m_request;

            this.setProgress();

            var fd = this.m_formData;

            var themeURL = (this.getParent() && this.getParent().$Type == "Theme") ? this.m_urlParent : this.m_urlNode;

            new PostRequest(req.m_module, req.m_operation)
                .addParameter("ParentURL", themeURL)
                .addParameter("Style",fd.getFieldValue("Style"))
                .addParameter("BOMSubtype", fd.getFieldValue("BOMSubtype"))
                .addParameter("BOMName",fd.getFieldValue("BOMName"))
                .post({}).then(lang.hitch(this, this._onPublishResponse));
        }
    });
});